import { IAdminText } from '../../components/admin/supervisors/interfaces';
import {
    AdminTextAction,
    AdminTextActionType,
} from '../actionTypes/adminTexts';

const adminTextReducer = (
    state: Array<IAdminText> = [],
    action: AdminTextAction
) => {
    let index: number;
    let newState: IAdminText[];
    switch (action.type) {
        case AdminTextActionType.CREATE_ADMIN_TEXT:
            return [...state, action.payload];
        case AdminTextActionType.UPDATE_ADMIN_TEXT:
            index = state.findIndex(
                (item) => item._id === action.payload?._id ?? 0
            );
            state[index] = { ...action.payload };
            return [...state];
        case AdminTextActionType.GET_ADMIN_TEXTS_BY_ROLE:
        case AdminTextActionType.GET_ALL_ADMIN_TEXTS:
            return action.payload as Array<IAdminText>;
        case AdminTextActionType.DELETE_ADMIN_TEXT:
            newState = state.filter(
                (item) => item._id !== action.payload?._id ?? 0
            );
            return [...newState];
        default:
            return state;
    }
};

export default adminTextReducer;
